// Frozen synthetic Ledger projection fixture for local Lens proof only.
// No provider, DB, route, storage, or real finance rows are read here.
export const FROZEN_LEDGER_PROJECTION_RESPONSE = Object.freeze({
  projection: {
    metadata: {
      bookId: 'SYN-BOOK-PROJ-001',
      currencyCode: 'PHP',
      projectionStartDate: '2026-06-01',
      horizonMonths: 3,
      source: 'book_read_only_local',
    },
    projectedIncomeStatement: {
      revenue: 300000,
      expenses: 111000,
      netIncome: 189000,
    },
    projectedCashFlow: {
      cashInflow: 300000,
      cashOutflow: 75000,
      endingCash: 275000,
    },
    projectedBalanceSheet: {
      netFixedAssets: 94000,
      totalAssets: 369000,
      accountsPayable: 30000,
      equity: 339000,
      isBalanced: true,
    },
    balanceChecks: {
      balanceSheetBalanced: true,
      difference: 0,
    },
    warnings: [],
  },
  proof: {
    source: 'frozen_local_book_read_only_response',
    localHarnessAccepted: true,
    serverTypecheckPassed: true,
    providerState: 'supabase_blocked_migrations_failed',
    proofMatrixAccepted: true,
  },
  guardrails: {
    readOnly: true,
    tenantScoped: true,
    bookAuthority: 'active_tenant_context_book_id',
    bodyBookIdIgnored: true,
    crossBookRowsHardStopBeforeCalculation: true,
    writesLedger: false,
    writesForecastScenario: false,
    writesBudget: false,
    writesLensStorage: false,
    usesRealFinanceData: false,
    usesProvider: false,
  },
  warningGroups: [
    {
      category: 'provenance',
      tone: 'warn',
      state: 'frozen local fake response',
      detail: 'Local proof only; not hosted, client, production, or real-finance evidence.',
    },
    {
      category: 'mapping',
      tone: 'good',
      state: 'synthetic mapping clear',
      detail: 'Known fake rows map into the accepted proof matrix; missing real mappings stay outside this panel.',
    },
    {
      category: 'timing',
      tone: 'warn',
      state: 'cash timing fixture-defined',
      detail: 'Accrual and cash timing come from the synthetic matrix; unsupported timing remains warning-first.',
    },
    {
      category: 'scope',
      tone: 'good',
      state: 'single synthetic book',
      detail: 'Scope is locked to SYN-BOOK-PROJ-001; branch, entity, and consolidated views are excluded.',
    },
    {
      category: 'provider-readiness',
      tone: 'bad',
      state: 'Supabase blocked: MIGRATIONS_FAILED',
      detail: 'Hosted lab proof is still blocked; this panel reads only the frozen local response.',
    },
    {
      category: 'safety',
      tone: 'good',
      state: 'no writeback path',
      detail: 'Read-only, tenant-scoped guardrails are visible; no persistence path is present here.',
    },
  ],
  labState: {
    local: 'green',
    vercel: 'pending',
    supabase: 'blocked: MIGRATIONS_FAILED',
  },
});

export const FROZEN_PROJECTION_ACCEPTANCE_VALUES = Object.freeze({
  projectedRevenue: 300000,
  projectedExpenses: 111000,
  projectedNetIncome: 189000,
  projectedCashInflow: 300000,
  projectedCashOutflow: 75000,
  endingCash: 275000,
  endingNetFixedAssets: 94000,
  endingAssets: 369000,
  endingAccountsPayable: 30000,
  endingEquity: 339000,
  balanceSheetBalanced: true,
});

export const FROZEN_PROJECTION_SOURCE_CHIPS = Object.freeze([
  { label: 'Source', value: 'local fixture + book_read_only local', tone: 'warn' },
  { label: 'Scope', value: 'single synthetic book', tone: 'good' },
  { label: 'Safety', value: 'read-only tenant-scoped active-book-authoritative', tone: 'good' },
  { label: 'Lab', value: 'local green; Vercel pending; Supabase blocked', tone: 'bad' },
]);
